export const STORE_PREFIX = 'bcg_'; // префикс для стор чтобы было уникальным
